import script from "./TopNavigation.vue?vue&type=script&lang=ts&setup=true"
export * from "./TopNavigation.vue?vue&type=script&lang=ts&setup=true"

import "./TopNavigation.vue?vue&type=style&index=0&id=810817be&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-810817be"]])

export default __exports__